class SuccessModalModel {
    constructor() {
        this.successMessage = 'we will send you the username and password of your newly registered account.';
    }
};

export default SuccessModalModel;


// WEBPACK FOOTER //
// ./client/app/pages/customer/deposit/model/success.modal.model.js